import Vue from 'vue'
import VueRouter from 'vue-router'
import { getDeviceType } from '@/utils/device'

// Routes: use lazy imports to reduce cold-start cost (especially on watch)
const PatientsView = () => import('../pages/patients/index.vue')
const DoctorHome = () => import('../pages/homePage/doctorHome.vue')
const MyChart = () => import('../pages/bloodSugar/component/newChart.vue')
const QRCode = () => import('../pages/components/QRCode.vue')
const SmartTree = () => import('../pages/components/SmartTree.vue')
const CGMDetails = () => import('../pages/bloodSugar/component/CGMDetails.vue')
const PersonnelManagement = () => import('../pages/personnelManagement/index.vue')
const HospitalList = () => import('../pages/personnelManagement/hospitalList.vue')
const alarmCFG = () => import('../pages/bloodSugar/component/alarmCFG.vue')
const wangEmitter = () => import('../pages/bloodSugar/component/wangEmitter.vue')
const departmentList = () => import('../pages/personnelManagement/departmentList.vue')
const departmentView = () => import('../pages/personnelManagement/components/departmentView.vue')
const adminMain = () => import('../pages/admin/adminMain.vue')
const passwordLogin = () => import('../pages/login/passwordLogin.vue')
const register = () => import('../pages/login/register.vue')
const login = () => import('../pages/login/index.vue')
const sijoyService = () => import('../pages/login/sijoyService.vue')
const sijoyPrivacy = () => import('../pages/login/sijoyPrivacy.vue')
const BloodSugar = () => import('../pages/bloodSugar/indexNew.vue')
const ReportCenter = () => import('../pages/reportCenter/index.vue')
const FollowReportCenter = () => import('../pages/reportCenter/followIndex.vue')
const kfyView = () => import('../pages/recordDetail/recordView/kfyView.vue')
const tsView = () => import('../pages/recordDetail/recordView/tsView.vue')
const ydsView = () => import('../pages/recordDetail/recordView/ydsView.vue')
const ydView = () => import('../pages/recordDetail/recordView/ydView.vue')
const zxView = () => import('../pages/recordDetail/recordView/zxView.vue')
const xyView = () => import('../pages/recordDetail/recordView/xyView.vue')
const xzView = () => import('../pages/recordDetail/recordView/xzView.vue')
const nsView = () => import('../pages/recordDetail/recordView/nsView.vue')
const cxView = () => import('../pages/recordDetail/recordView/cxView.vue')
const RecordDetail = () => import('../pages/recordDetail/index.vue')
const RecordAdd = () => import('../pages/recordDetail/recordAdd.vue')
const NoFollow = () => import('../pages/recordDetail/noFollow.vue')
const FollowView = () => import('../pages/recordDetail/followView.vue')
const MineView = () => import('../pages/mineView/indexNew.vue')
const AiAssistant = () => import('../pages/aiAssistant/index.vue')
const AiBiochemSelect = () => import('../pages/aiAssistant/biochemSelect.vue')
const addRelationshipByCode = () => import('../pages/personnelManagement/addRelationshipByCode.vue')
const GJEmpower = () => import('../pages/homePage/component/GJEmpower.vue')
const SNEmpower = () => import('../pages/homePage/component/SNEmpower.vue')
const userTable = () => import('../pages/admin/dataTable/userTable.vue')
const alarmCFG0 = () => import('../pages/mineView/component/alarmCFG0.vue')
// 医生认证和推广员认证模块
const authentication = () => import('../pages/mineView/component/authentication.vue')
const promoter = () => import('../pages/mineView/component/promoter.vue')
const hospitalAdd = () => import('../pages/mineView/component/hospitalAdd.vue')
const hospitalNo = () => import('../pages/mineView/component/hospitalNo.vue')
const hospitalView = () => import('../pages/mineView/component/hospitalView.vue')
const doctorAdd = () => import('../pages/mineView/component/doctorAdd.vue')
// 关注模块
const myHospital = () => import('../pages/recordDetail/component/myHospital.vue')
const myPatients = () => import('../pages/recordDetail/component/myPatients.vue')
// loop闭环模块
const loopHandle = () => import('../pages/mineView/component/loopHandle.vue')
const loopHandleList = () => import('../pages/mineView/component/loopHandleList.vue')
const loopDetails = () => import('../pages/bloodSugar/component/loopDetails.vue')
Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // {
  //   path: '/',
  //   redirect: '/BloodSugar',
  // },
  {
    path: '/',
    name: 'Root',
    // 这里不写 redirect，交给路由守卫处�?
    component: { template: '<router-view />' },
  },
  {
    path: '/userTable',
    name: 'userTable',
    component: userTable,
  },
  {
    path: '/BloodSugar',
    name: 'BloodSugar',
    component: BloodSugar,
  },
  {
    path: '/BloodSugar/GJEmpower',
    name: 'GJEmpower',
    component: GJEmpower,
  },
  {
    path: '/BloodSugar/SNEmpower',
    name: 'SNEmpower',
    component: SNEmpower,
  },
  {
    path: '/OTEmpower',
    name: 'OTEmpower',
    component: () => import('@/pages/homePage/component/OTEmpower.vue'),
  },
  // 爱奥乐血糖仪连接页面
  {
    path: '/AioLeBloodGlucoseEmpower',
    name: 'AioLeBloodGlucoseEmpower',
    component: () => import('@/pages/homePage/component/AioLeBloodGlucoseEmpower.vue')
  },
  // 爱奥乐血压仪连接页面
  {
    path: '/AioLeBloodPressureEmpower',
    name: 'AioLeBloodPressureEmpower',
    component: () => import('@/pages/homePage/component/AioLeBloodPressureEmpower.vue')
  },
  {
    path: '/AioLeDeviceDataList',
    name: 'AioLeDeviceDataList',
    component: () => import('@/pages/homePage/component/AioLeDeviceDataList.vue')
  },
  // 旧爱奥乐连接地址兼容到血糖仪页面
  {
    path: '/AioLeEmpower',
    redirect: '/AioLeBloodGlucoseEmpower'
  },
  // 鱼跃动态cgm授权页面
  {
    path: '/YYEmpower',
    name: 'YYEmpower',
    component: () => import('@/pages/homePage/component/YYEmpower.vue')
  },
  // 稳连 CGM 授权页面
  {
    path: '/WLEmpower',
    name: 'WLEmpower',
    component: () => import('@/pages/homePage/component/WLEmpower.vue')
  },
  //稳连授权成功页面
  {
    path: '/WLredirect',
    name: 'WLredirect',
    component: () => import('@/pages/homePage/component/WLredirect.vue')
  },
  // 鱼跃动态cgm授权成功页面
  {
    path: '/YYSuccess',
    name: 'YYSuccess',
    component: () => import('@/pages/homePage/component/YYSuccess.vue')
  },
  {
    path: '/MineView',
    name: 'MineView',
    component: MineView,
  },
  {
    path: '/aiAssistant',
    name: 'AiAssistant',
    component: AiAssistant,
  },
  {
    path: '/aiBiochemSelect',
    name: 'AiBiochemSelect',
    component: AiBiochemSelect,
  },
  {
    path: '/RecordDetail',
    name: 'RecordDetail',
    component: RecordDetail,
  },
  // 添加关注�?
  {
    path: '/RecordAdd',
    name: 'RecordAdd',
    component: RecordAdd,
  },
  // 未关注页
  {
    path: '/NoFollow',
    name: 'NoFollow',
    component: NoFollow,
  },
  // 未关注页
  {
    path: '/FollowView',
    name: 'FollowView',
    component: FollowView,
  },
  // 白板页面
  {
    path: '/baiban',
    name: 'baiban',
    component: () => import('../pages/recordDetail/baiban.vue'),
  },
  // 血糖指导等待页�?-医生
  {
    path: '/waitingA',
    name: 'waitingA',
    component: () => import('../pages/recordDetail/waitingA.vue'),
  },
  // 血糖指导等待页�?-患�?
  {
    path: '/waitingB',
    name: 'waitingB',
    component: () => import('../pages/recordDetail/waitingB.vue'),
  },
  // 登陆账号报告�?
  {
    path: '/ReportCenter',
    name: 'ReportCenter',
    component: ReportCenter,
  },
  // 关注用户报告�?
  {
    path: '/FollowReportCenter',
    name: 'FollowReportCenter',
    component: FollowReportCenter,
  },
  {
    path: '/ReportCenter/kfyView',
    name: 'kfyView',
    component: kfyView,
  },
  {
    path: '/ReportCenter/tsView',
    name: 'tsView',
    component: tsView,
  },
  {
    path: '/ReportCenter/ydsView',
    name: 'ydsView',
    component: ydsView,
  },
  {
    path: '/ReportCenter/ydView',
    name: 'ydView',
    component: ydView,
  },
  {
    path: '/ReportCenter/zxView',
    name: 'zxView',
    component: zxView,
  },
  {
    path: '/ReportCenter/xyView',
    name: 'xyView',
    component: xyView,
  },
  {
    path: '/ReportCenter/xzView',
    name: 'xzView',
    component: xzView,
  },
  {
    path: '/ReportCenter/nsView',
    name: 'nsView',
    component: nsView,
  },
  {
    path: '/ReportCenter/cxView',
    name: 'cxView',
    component: cxView,
  },
  {
    path: '/MineView/adminMain',
    name: 'adminMain',
    component: adminMain,
  },
  {
    path: '/passwordLogin',
    name: 'passwordLogin',
    component: passwordLogin,
  },
  // 注册
  {
    path: '/register',
    name: 'register',
    component: register,
  },
  // 微信扫描医院码跳转此页面加入医院，然后跳到硅基授权页�?
  {
    path: '/addPatient',
    name: 'addPatient',
    component: () => import('@/pages/patients/addPatient.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  {
    path: '/sijoyService',
    name: 'sijoyService',
    component: sijoyService,
  },
  {
    path: '/sijoyPrivacy',
    name: 'sijoyPrivacy',
    component: sijoyPrivacy,
  },
  {
    path: '/departmentList',
    name: 'departmentList',
    component: departmentList,
  },
  {
    path: '/departmentView',
    name: 'departmentView',
    component: departmentView,
  },
  {
    path: '/QRCode',
    name: 'QRCode',
    component: QRCode,
  },
  {
    path: '/MineView/PersonnelManagement',
    name: 'PersonnelManagement',
    component: PersonnelManagement,
  },
  {
    path: '/hospitalList',
    name: 'HospitalList',
    component: HospitalList,
  },
  {
    path: '/CGMDetails',
    name: 'CGMDetails',
    component: CGMDetails,
  },
  {
    path: '/SmartTree',
    name: 'SmartTree',
    component: SmartTree,
  },
  {
    path: '/BloodSugar/alarmCFG',
    name: 'alarmCFG',
    component: alarmCFG,
  },
  {
    path: '/MineView/alarmCFG0',
    name: 'alarmCFG0',
    component: alarmCFG0,
  },
  {
    path: '/BloodSugar/wangEmitter',
    name: 'wangEmitter',
    component: wangEmitter,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  {
    path: '/PatientsView',
    name: 'PatientsView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: PatientsView,
  },
  {
    path: '/MyChart',
    name: 'MyChart',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: MyChart,
  },
  {
    path: '/doctorHome',
    name: 'DoctorHome',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: DoctorHome,
  },
  {
    path: '/addRelationshipByCode',
    name: 'addRelationshipByCode',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: addRelationshipByCode,
  },
  // 医生认证
  {
    path: '/authentication',
    name: 'authentication',
    component: authentication,
  },
  // 医生认证
  {
    path: '/promoter',
    name: 'promoter',
    component: promoter,
  },
  // 添加医院
  {
    path: '/hospitalAdd',
    name: 'hospitalAdd',
    component: hospitalAdd,
  },
  // 待审核医�?
  {
    path: '/hospitalNo',
    name: 'hospitalNo',
    component: hospitalNo,
  },
  // 医院详情
  {
    path: '/hospitalView',
    name: 'hospitalView',
    component: hospitalView,
  },
  // 添加医生
  {
    path: '/doctorAdd',
    name: 'doctorAdd',
    component: doctorAdd,
  },
  // 关注页面我的医院
  {
    path: '/myHospital',
    name: 'myHospital',
    component: myHospital,
  },
  // 我的医院下患者列�?
  {
    path: '/myPatients',
    name: 'myPatients',
    component: myPatients,
  },
  // loop闭环操作
  {
    path: '/MineView/loopHandle',
    name: 'loopHandle',
    component: loopHandle,
  },
  // loop操作列表
  {
    path: '/MineView/loopHandleList',
    name: 'loopHandleList',
    component: loopHandleList,
  },
  // loop详情信息
  {
    path: '/loopDetails',
    name: 'loopDetails',
    component: loopDetails,
  },
  {
    path: '/AssessReport',
    name: '病历报告',
    component: () => import('@/pages/assessReport/index'),
    hidden: true,
  },
  // 扫码添加患者信息页�?
  {
    path: '/bindingInfo',
    name: 'bindingInfo',
    component: () => import('@/pages/patients/bindingInfo.vue'),
  },
  // 患者病历页�?
  {
    path: '/patientCases',
    name: 'patientCases',
    component: () => import('@/pages/patients/patientCases.vue'),
  },
  // 医生扫描二维码加入医�?
  {
    path: '/joinHospital',
    name: 'joinHospital',
    component: () => import('@/pages/mineView/component/joinHospital.vue'),
  },
  // 硅基授权码页�?
  {
    path: '/GJcode',
    name: 'GJcode',
    component: () => import('@/pages/mineView/component/GJcode.vue'),
  },
  // 闭环血糖页�?
  {
    path: '/nsPage',
    name: 'nsPage',
    component: () => import('@/pages/nsPages/index.vue'),
  },
  // 商城
  {
    path: '/shop',
    name: 'shop',
    component: () => import('@/pages/shop.vue'),
  },
  // 编辑头像
  {
    path: '/editAva',
    name: 'editAva',
    component: () => import('@/pages/mineView/component/editAva.vue'),
  },
  // 个人信息
  {
    path: '/mineEdit',
    name: 'mineEdit',
    component: () => import('@/pages/mineView/component/editDialog.vue'),
  },
  // 软件更新
  {
    path: '/updateApp',
    name: 'updateApp',
    component: () => import('@/pages/mineView/component/updateApp.vue'),
  },
  // 软件更新详情
  {
    path: '/versionDetail',
    name: 'versionDetail',
    component: () => import('@/pages/mineView/component/versionDetail.vue'),
  },
  // 配置文件
  {
    path: '/configFile',
    name: 'configFile',
    component: () => import('@/pages/mineView/configFile.vue'),
  },
  // 热力图写8点血�?
  {
    path: '/hotChart',
    name: 'hotChart',
    component: () => import('@/pages/hotChart/hotChart.vue'),
  },
  // 患者概�?
  {
    path: '/patientInfo',
    name: 'patientInfo',
    component: () => import('@/pages/reportCenter/patientInfo.vue'),
  },
  // 新版首页
  {
    path: '/index',
    redirect: '/BloodSugar',
  },
  // 糖仁事件页面
  {
    path: '/trEvent',
    name: 'trEvent',
    component: () => import('@/pages/bloodSugar/trEvent.vue'),
  },
  // 糖仁事件页面
  {
    path: '/text',
    name: 'text',
    component: () => import('@/pages/mineView/index.vue'),
  },
  // 导出报告页面
  {
    path: '/exReport',
    name: 'exReport',
    component: () => import('@/pages/reportCenter/exReport.vue'),
  },
  // 给阿瑞授权登录页�?
  {
    path: '/arui',
    name: 'arui',
    component: () => import('@/pages/authorize/arui.vue'),
  },
  // 给阿瑞授权页�?
  {
    path: '/aruiAuth',
    name: 'aruiAuth',
    component: () => import('@/pages/authorize/aruiAuth.vue'),
  },
  // 阿瑞取消授权页面
  {
    path: '/authSucess',
    name: 'authSucess',
    component: () => import('@/pages/authorize/authSucess.vue'),
  },
  // 新增添加血糖仪页面
  {
    path: '/cgmPage',
    name: 'cgmPage',
    component: () => import('@/pages/bloodSugar/cgmPage.vue'),
  },
  // 凯联胰岛素笔页面
  {
    path: '/insulinPen',
    name: 'insulinPen',
    component: () => import('@/pages/pen/insulinPen'),
  },
  // 快舒尔胰岛素笔页�?
  {
    path: '/insulinPen_kser',
    name: 'insulinPen_kser',
    component: () => import('@/pages/pen/insulinPen_kser'),
  },
  {
    path: '/insulinPen_wzb',
    name: 'insulinPen_wzb',
    component: () => import('@/pages/pen/insulinPen_wzb'),
  },
  {
    path: '/wzbInsulinType',
    name: 'wzbInsulinType',
    component: () => import('@/pages/pen/wzbInsulinType'),
  },
  // 计算器页�?
  {
    path: '/calculator',
    name: 'calculator',
    component: () => import('@/pages/pen/calculator.vue'),
  },
  {
    path: '/habitCalculator',
    name: 'habitCalculator',
    component: () => import('@/pages/pen/habitCalculator.vue'),
  },
  {
    path: '/glucosePrediction',
    name: 'glucosePrediction',
    component: () => import('@/pages/pen/glucosePrediction.vue'),
  },
  // 计算器参数设置页�?
  {
    path: '/settingPage',
    name: 'settingPage',
    component: () => import('@/pages/pen/settingPage.vue'),
  },
  // 用药计划
  {
    path: '/insulinPlan',
    name: 'insulinPlan',
    component: () => import('@/pages/pen/insulinPlan.vue'),
  },
  // 手表页面
  {
    path: '/watchChart',
    name: 'WatchChart',
    component: () => import('@/pages/watchChart/index.vue'),
  },
  // 手表软件下载
  {
    path: '/watchGetApp',
    name: 'watchGetApp',
    component: () => import('@/pages/watchChart/watchGetApp.vue'),
  },
  // 手表选择动�?
  {
    path: '/watchCgmPage',
    name: 'watchCgmPage',
    component: () => import('@/pages/watchChart/watchCgmPage.vue'),
  },
  // 手表个人信息
  {
    path: '/watchInfo',
    name: 'watchInfo',
    component: () => import('@/pages/watchChart/watchInfo.vue'),
  },
  // 患者问诊页�?
  {
    path: '/inquiry',
    name: 'inquiry',
    component: () => import('@/pages/inquiry/index.vue'),
  },
  // 患者聊天页�?
  {
    path: '/chatPage',
    name: 'chatPage',
    component: () => import('@/pages/inquiry/chatPage.vue'),
  },
  // 诊室设置页面
  {
    path: '/roomSetting',
    name: 'roomSetting',
    component: () => import('@/pages/inquiry/roomSetting.vue'),
  },
  // 聊天室报告页�?
  {
    path: '/chatReport',
    name: 'chatReport',
    component: () => import('@/pages/inquiry/chatReport.vue'),
  },
  // 聊天室查看患者病�?
  {
    path: '/chatCase',
    name: 'chatCase',
    component: () => import('@/pages/inquiry/chatCase.vue'),
  },
  // 安卓用隐私协议和用户服务
  {
    path: '/sijoyPrivacyAndroid',
    name: 'sijoyPrivacyAndroid',
    component: () => import('@/pages/login/sijoyPrivacyAndroid.vue'),
  },
  {
    path: '/sijoyServiceAndroid',
    name: 'sijoyServiceAndroid',
    component: () => import('@/pages/login/sijoyServiceAndroid.vue'),
  },
  {
    path: '/HsBloodGlucoseDevice',
    name: 'HsBloodGlucoseDevice',
    component: () => import('@/pages/mineView/HsBloodGlucoseDevice.vue'),
  },
  // 我的设备-测血脂、尿酸的设备
  {
    path: '/myDevice',
    name: 'myDevice',
    component: () => import('@/pages/mineView/myDevice.vue'),
  },
]

const router = new VueRouter({
  routes,
  // 保证路由跳转页面之后，都保持在页面的最顶端
  scrollBehavior(to, form, savedPosition) {
    return { x: 0, y: 0 }
  },
})
const whiteList = [
  '/login',
  '/passwordLogin',
  '/WLredirect',
  '/addPatient',
  '/arui',
  '/aruiAuth',
  '/authSucess',
  '/sijoyPrivacy',
  '/sijoyService',
  '/sijoyPrivacyAndroid',
  '/sijoyServiceAndroid',
  '/watchChart',
  '/watchInfo',
]
const watchAllowList = ['/watchChart', '/watchInfo', '/watchinfo', '/watchGetApp', '/sijoyPrivacyAndroid', '/sijoyServiceAndroid']
// router.beforeEach((to, from, next) => {
router.beforeEach((to, from, next) => {
  const loginStatus = localStorage.getItem('loginStatus')
  const isLoggedIn = loginStatus === 'true'
  const device = getDeviceType()

  if (to.path === '/') {
    next(device === 'watch' ? '/watchChart' : '/BloodSugar')
    return
  }

  if (device === 'watch') {
    next()
    return
  }

  if (!isLoggedIn && !whiteList.includes(to.path)) {
    next('/login')
  } else {
    next()
  }
})

export default router

